module.exports = __webpack_public_path__ + "img/faq_main.333fbf2d.png";